import { render, staticRenderFns } from "./FilesCard.vue?vue&type=template&id=3b1eb976&scoped=true&"
import script from "./FilesCard.vue?vue&type=script&lang=js&"
export * from "./FilesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1eb976",
  null
  
)

export default component.exports